import React from 'react';
import { Tabs } from 'antd';
import CourseOfferList from './CourseOfferList';
import CourseOfferCalendarView from './CourseOfferCalendarView';

const { TabPane } = Tabs;

const CourseOffers = () => {
  return (
    <div>
      <Tabs defaultActiveKey="1">
        <TabPane tab="List view" key="1">
          <CourseOfferList />
        </TabPane>
        <TabPane tab="Calendar view" key="2">
          <CourseOfferCalendarView />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default CourseOffers;
